import React, { useEffect, useState } from "react";
import styled from "styled-components";
import QuantityInput from "../common/QuantityInput";
import { useRequest } from "../../hooks/useRequest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Progress from "../common/Progress";
import AddToWishlist from "../modals/AddToWishlist";
import CreateWishlistModal from "../modals/CreateWishlistModal";
import { priceSymbol } from "../../utils/symbol";
import Image from "../Image/Image";

const CartProductCardStyle = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 24px;
  gap: 10px;
  position: relative;
  .cart__product__wrapper {
    flex: 1;
    display: flex;
    gap: 18px;
    padding-right: 40px;
    .cart__product__image {
      width: 82px;
      height: 114px;
    }
    .cart__product__details {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #303030;
      padding: 5px 0;
      .cart__product__category {
        font-size: 11.25px;
        font-weight: 400;
        line-height: 15px;
      }
      .cart__product__title {
        font-size: 15px;
        font-weight: 600;
        line-height: 22.5px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-transform: capitalize;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .cart__product__variations {
        margin-top: 4px;
      }
      .cart__product__variant {
        color: #303030;
        font-size: 12px;
        font-weight: 600;
        line-height: 18px;
        margin-bottom: 2px;
        span {
          font-weight: 400;
        }
        .variation-price {
          color: #ae0000;
          margin-left: 4px;
        }
      }
    }
  }
  .cart__cell {
    flex: 0 0 120px;
  }
  .cart__product__price,
  .cart__product__total,
  .cart__product__qty {
    color: #303030;
    font-size: 15px;
    font-weight: 600;
    line-height: 22.5px;
    text-align: center;
  }
  .cart__product__qty {
    display: flex;
    justify-content: center;
  }
  .cart__product__total {
    flex: 0 0 90px;
    text-align: right;
  }
  .cart__product__card__actions {
    display: flex;
    gap: 32px;
    position: absolute;
    right: 25px;
    bottom: 18px;
    .cart__product__wishlist,
    .cart__product__remove {
      color: #ae0000;
      background-color: #fff;
      font-size: 12px;
      font-weight: 500;
      line-height: 20px;
      &:hover {
        text-decoration: underline;
      }
    }
    .cart__product__wishlist {
      input {
        position: absolute;
        left: 18px;
        width: 32px;
        transform: scaleX(6);
        width: 14px;
        transform: scaleX(4);
        opacity: 0;
      }
    }
    .cart__product__remove {
      color: #000000;
      display: flex;
      align-items: center;
      gap: 2px;
    }
  }
  .cart__product__coupon {
    margin-top: 8px;
    font-size: 12px;
    color: #4caf50;
    .coupon__code {
      font-weight: 600;
    }
    .coupon__discount {
      margin-left: 4px;
    }
  }
  .cart__product__coupon_form {
    margin-top: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
    
    .coupon__input {
      flex: 1;
      padding: 8px 12px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 13px;
      
      &.error {
        border-color: #ff0000;
      }
      
      &:focus {
        outline: none;
        border-color: #ae0000;
      }
    }
    
    .apply__btn {
      padding: 8px 16px;
      background: #ae0000;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 13px;
      cursor: pointer;
      
      &:disabled {
        background: #ccc;
        cursor: not-allowed;
      }
    }
    
    .invalid__coupon {
      color: #ff0000;
      font-size: 12px;
      margin-top: 4px;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    padding: 15px 15px 30px;
    gap: 4px;
    justify-content: space-between;
    .cart__product__wrapper {
      flex: auto;
      padding-right: 70px;
      gap: 12px;
      .cart__product__details .cart__product__title {
        font-size: 14px;
        -webkit-line-clamp: 3;
      }
      .cart__product__image {
        width: 70px;
        height: 70px;
      }
    }
    .cart__product__total {
      position: absolute;
      right: 15px;
      top: 15px;
    }
    .cart__product__price {
      margin-left: 84px;
    }
    .cart__product__card__actions {
      bottom: 12px;
      right: auto;
      left: 98px;
    }
    .cart__product__price,
    .cart__product__total,
    .cart__product__qty {
      flex: 0;
      font-size: 12px;
    }
    .cart__product__details {
      .cart__product__variations {
        margin-top: 2px;
      }
      .cart__product__variant {
        font-size: 11px;
        line-height: 16px;
      }
    }
    .cart__summary__coupon {
      margin-top: 12px;
      padding: 12px;

      .coupon_form {
        flex-direction: column;
        gap: 8px;

        .apply_btn {
          width: 100%;
        }
      }
    }
  }
`;

const CouponForm = styled.div`
  .cart__summary__coupon {
    margin-top: 16px;
    padding: 16px;

    .cart__summary__coupon__title {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 12px;
    }

    .coupon_form {
      display: flex;
      gap: 8px;
      margin-bottom: 8px;

      .cart__summary__coupon__input {
        flex: 1;
        padding: 8px 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 13px;
        transition: all 0.2s ease;

        &::placeholder {
          color: #999;
        }

        &:focus {
          border-color: #ae0000;
          outline: none;
        }

        &.error {
          border-color: #ff0000;
        }
      }

      .apply_btn {
        padding: 8px 16px;
        background: #ae0000;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 500;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: #8c0000;
        }

        &:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
      }
    }

    .invalid__coupon {
      color: #ff0000;
      font-size: 12px;
      margin-top: 6px;
    }

    .cart__summary__subtitle {
      font-size: 12px;
      color: #666;
      margin-top: 8px;
    }
  }

  @media (max-width: 768px) {
    .cart__summary__coupon {
      margin-top: 12px;
      padding: 12px;

      .coupon_form {
        flex-direction: column;
        gap: 8px;

        .apply_btn {
          width: 100%;
        }
      }
    }
  }
`;

const CartProductCard = ({
  src,
  title,
  isSchedule,
  price,
  total,
  itemQuantity,
  loading,
  category,
  variant,
  itemId,
  setIsQtyChanged,
  setIsCheckoutButtonDisabled,
  product,
  cartId,
  instabuildId = "",
  scheduleDate,
  stock,
  variations,
  coupon
}) => {
  const [handleIncDec, { isLoading }] = useRequest();
  const navigate = useNavigate();
  const [handleReq, { isReqloading }] = useRequest();
  const [isAddToWishlistActive, setIsAddToWishlistActive] = useState(false);
  const [isCreateWishlistActive, setIsCreateWishlistActive] = useState(false);
  const [scheduledDate, setScheduledDate] = useState(scheduleDate?.split("T")[0]);
  const [couponCode, setCouponCode] = useState(coupon?.code || "");
  const [isCouponInvalid, setIsCouponInvalid] = useState(false);
  const [handleUpdateCoupon, { isLoading: isUpdateCouponLoading }] = useRequest();

  if (loading) {
    return <CartProductCardStyle></CartProductCardStyle>;
  }

  const handleIncrementDecrement = async (itemId, quantity) => {
    setIsCheckoutButtonDisabled && setIsCheckoutButtonDisabled(true);
    if (isLoading) return;
    const path = !instabuildId?.length
      ? `/cart`
      : `/instacart/instabuild/${instabuildId}`;
    const response = await handleIncDec({
      path,
      method: "POST",
      body: JSON.stringify({
        productId: itemId,
        quantity: quantity,
        deliveryDate: "",
        variation: JSON.stringify(variations ?? []),
      }),
    });
    if (!response.success) {
      toast.error(response?.message || "Error changing quantity of items");
    }
    setIsQtyChanged && setIsQtyChanged((prev) => !prev);
  };

  const handleInc = () => {
    handleIncrementDecrement(itemId, +1);
  };

  const handleDec = () => {
    handleIncrementDecrement(itemId, -1);
  };

  const handleCoupon = async () => {
    if (!couponCode.trim()) {
      toast.error("Please enter a coupon code");
      return;
    }

    try {
      const response = await handleUpdateCoupon({
        path: `/cart/${cartId}/update-coupon`,
        method: "PUT",
        body: JSON.stringify({
          productId: itemId,
          couponCode: couponCode.trim()
        })
      });

      if (response.success) {
        const { productId, coupon } = response.data;

        if (coupon) {
          setCouponCode(coupon.code);
          toast.success(`Coupon applied successfully to ${coupon.appliedQuantity} item(s)`);
          setIsCouponInvalid(false);
        } else {
          setCouponCode("");
          toast.success("Coupon removed successfully");
        }

        setIsQtyChanged && setIsQtyChanged((prev) => !prev);
      } else {
        setIsCouponInvalid(true);
        toast.error(response.message || "Failed to apply coupon");
      }
    } catch (error) {
      setIsCouponInvalid(true);
      toast.error("Failed to apply coupon");
    }
  };


  const removeCoupon = async () => {
    const response = await handleUpdateCoupon({
      path: `/cart/${cartId}/remove-coupon?productId=${itemId}`,
      method: "DELETE",
    });
    if (response.success) {
      setCouponCode("");
      toast.success("Coupon removed successfully");
      setIsQtyChanged && setIsQtyChanged((prev) => !prev);
    } else {
      toast.error(response.message || "Failed to remove coupon");
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setIsCouponInvalid(false);
    setCouponCode(value);
  };

  const handleTitleClick = (product) => {
    const path = `/product/${product?.slug}?id=${product?.id}`;
    navigate(path);
  };

  const handleRemoveClick = async (cartId, productId) => {
    const path = `/cart/${cartId}/clear-product/${productId}`;
    const response = await handleReq({ path, method: "DELETE" });
    if (!response.success) {
      return toast.error(response.message);
    }
    toast.success(response.message);
    setIsQtyChanged && setIsQtyChanged((prev) => !prev);
  };

  const handleCartAction = () => {
    if (!instabuildId?.length) {
      setIsAddToWishlistActive(true);
    }
  };

  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setScheduledDate(selectedDate || "null");
  };

  useEffect(() => {
    const handleSchedule = async (cartId, itemId, scheduledDate) => {
      const response = await handleReq({
        path: `/instacart/instabuild/${cartId}/schedule-product`,
        method: "POST",
        body: JSON.stringify({
          productId: itemId,
          deliveryDate:
            scheduledDate && scheduledDate !== "null" ? scheduledDate : "",
        }),
      });
      if (!response?.success) {
        setScheduledDate("");
        return toast.error(response?.message, { toastId: "error" });
      }
      return toast.success(response?.message);
    };
    if (scheduledDate !== scheduleDate?.split("T")[0] && cartId && itemId) {
      handleSchedule(cartId, itemId, scheduledDate);
    }
  }, [cartId, itemId, scheduledDate]);

  const calculateDiscountAmount = () => {
    if (!coupon) return 0;
    return coupon.discountAmount;
  };

  return (
    <>
      <CartProductCardStyle>
        <div className="cart__product__wrapper">
          <div className="cart__product__image">
            <Image src={src} alt={title} />
          </div>
          <div className="cart__product__details">
            {category && <p className="cart__product__category">{category}</p>}
            {title && (
              <p
                className="cart__product__title"
                onClick={() => handleTitleClick(product)}
                title={title}
              >
                {title}
              </p>
            )}
            {variations && variations.length > 0 && (
              <div className="cart__product__variations">
                {variations.map((variation, index) => (
                  <p key={index} className="cart__product__variant">
                    {variation.name}: <span>{variation.value}</span>
                    <span className="variation-price"> (+{priceSymbol}{Number(variation?.price || 0).toFixed(2)})</span>
                  </p>
                ))}
              </div>
            )}
            {coupon && (
              <div className="cart__product__coupon">
                <span className="coupon__code">{coupon.code}</span>
                <span className="coupon__discount">
                  (-{priceSymbol}{calculateDiscountAmount().toFixed(2)})
                </span>
                <button
                  className="remove__coupon__btn"
                  onClick={removeCoupon}
                  style={{
                    marginLeft: '8px',
                    background: 'none',
                    border: 'none',
                    color: '#ae0000',
                    cursor: 'pointer',
                    fontSize: '12px',
                    padding: '0'
                  }}
                >
                  Remove
                </button>
              </div>
            )}
          </div>
        </div>
        <h2 className="cart__cell cart__product__price">
          {priceSymbol}
          {Number(price || 0)?.toFixed(2)}
        </h2>
        <div className="cart__cell cart__product__qty">
          <QuantityInput
            handleIncrement={handleInc}
            handleDecrement={handleDec}
            itemQuantity={itemQuantity}
            isDisabled={isLoading}
            productQuantity={itemQuantity}
            inputDisable={true}
          />
        </div>
        {stock ? (
          <h5 style={{ color: 'red', fontWeight: '500' }}>Out of Stock</h5>
        ) : (
          <h2 className="cart__cell cart__product__total">
            {priceSymbol}
            {Number(total || 0)?.toFixed(2)}
          </h2>
        )}

        <div className="cart__product__card__actions">
          <button
            className="cart__product__wishlist"
            onClick={handleCartAction}
          >
            {isSchedule
              ? scheduledDate && scheduledDate !== "null"
                ? scheduledDate
                : "Schedule"
              : "Add to wishlist"}
            {isSchedule && (
              <input
                type="date"
                onKeyDown={(e) => e.preventDefault()}
                className="input"
                onChange={handleDateChange}
                min={new Date().toISOString().split("T")[0]}
              />
            )}
          </button>
          <button
            className="cart__product__remove"
            onClick={() => handleRemoveClick(cartId, itemId)}
          >
            Remove
          </button>
        </div>
      </CartProductCardStyle>
      {isReqloading && <Progress />}
      {isAddToWishlistActive && (
        <AddToWishlist
          onMaskClick={() => setIsAddToWishlistActive(false)}
          product={product}
          handleSecondaryButtonClick={() => setIsCreateWishlistActive(true)}
          isCreateWishlistActive={isCreateWishlistActive}
        />
      )}
      {isCreateWishlistActive && (
        <CreateWishlistModal
          onMaskClick={() => setIsCreateWishlistActive(false)}
        />
      )}
      <CouponForm>
        <div className="cart__summary__coupon">
          <div className="cart__summary__coupon__title">Apply Coupon</div>
          <div className="coupon_form">
            <input
              type="text"
              placeholder="Enter coupon code (ex: FIRSTPAY)"
              className={`cart__summary__coupon__input ${isCouponInvalid ? "error" : ""}`}
              value={couponCode}
              onChange={handleChange}
            />
            <button
              disabled={isUpdateCouponLoading}
              onClick={handleCoupon}
              className="apply_btn"
            >
              {isUpdateCouponLoading ? "Applying..." : "Apply"}
            </button>
          </div>
          {isCouponInvalid && <span className="invalid__coupon">Invalid coupon code</span>}
          <p className="cart__summary__subtitle">Coupon code will be applied on the checkout page</p>
        </div>
      </CouponForm>
    </>
  );
};

export default CartProductCard;
